import script from "./PersonalStatisticsProgressViewGridLoader.vue?vue&type=script&setup=true&lang=js"
export * from "./PersonalStatisticsProgressViewGridLoader.vue?vue&type=script&setup=true&lang=js"

import "./PersonalStatisticsProgressViewGridLoader.vue?vue&type=style&index=0&id=575ada9a&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-575ada9a"]])

export default __exports__